import React, { FC, useState } from 'react';

import { IEvButtonProps } from '@evinced-private/ui-common';

import { removeMetaFieldsFromUrlSetConfig } from '../../helpers/UrlSetHelper';
import { IUrlSet } from '../../interfaces/UrlSet';
import { getScanUrlSetConfig } from '../../services/scan/ScansService';
import { JsonPopup } from '../json-popup/JsonPopup';

interface IScanConfigProps {
	scanId: string;
	triggerButtonProps: IEvButtonProps;
}

export const ScanConfigPopup: FC<IScanConfigProps> = ({ scanId, triggerButtonProps }) => {
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [urlSetConfig, setUrlSetConfig] = useState<IUrlSet>(null);

	const loadUrlSet = async (): Promise<void> => {
		setIsLoading(true);
		const urlSetConfig = await getScanUrlSetConfig(scanId);
		const cleanUrlSetConfig = removeMetaFieldsFromUrlSetConfig(urlSetConfig);
		setUrlSetConfig(cleanUrlSetConfig);
		setIsLoading(false);
	};

	const closePopup = (dataToSave, close: () => void): void => {
		close();
	};

	return (
		<JsonPopup
			title="Scan Url Set Configuration"
			initialValue={urlSetConfig}
			isReadonly={true}
			approveButtonText="Close"
			onApprove={closePopup}
			onOpen={loadUrlSet}
			triggerButtonProps={triggerButtonProps}
			isLoading={isLoading}
		/>
	);
};
